// extracted by mini-css-extract-plugin
export default {"wrapper":"subject_query_view_wrapper__aMSVU"};